/* 布局 */
//前台
import Layout from "@views/layout";

const goodspointsapplicationRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "goodspointsapplication",
            name: "GOODSPOINTSAPPLICATION",
            meta: {
                title: "积分申请",
                sort: 1,
            },
            component: () => import("@views/business/goodspointsapplication/index.vue"),
            redirect: {
                name: "GOODSPOINTSAPPLICATION_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "GOODSPOINTSAPPLICATION_LIST",
                    meta: {
                        title: "积分申请",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/goodspointsapplication/list.vue"),
                },
                {
                    path: "add",
                    name: "GOODSPOINTSAPPLICATION_ADD",
                    meta: {
                        title: "新增积分申请表",
                        parentPath: '/business/goodspointsapplication/list',
                        operate: true,
                    },
                    component: () => import("@views/business/goodspointsapplication/form.vue"),
                },
                {
                    path: "edit",
                    name: "GOODSPOINTSAPPLICATION_EDIT",
                    meta: {
                        title: "编辑积分申请表",
                        parentPath: '/business/goodspointsapplication/list',
                        operate: true,
                    },
                    component: () => import("@views/business/goodspointsapplication/form.vue"),
                },
            ],
        },


    ],
};

export default goodspointsapplicationRouter;
